import Modal from "../Modal";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import Radio from "../Radio";
import payTypes from "../../utils/payType";

export default function PayModal({
                                   visible,
                                   onClose,
                                   payType,
                                   selectPayType = () => null
                                 }) {
  const { t } = useTranslation();
  
  const _payTypes = payTypes;
  return (
    <Modal title={t('支付方式')}
           footer={null}
           width={800}
           visible={visible}
           onClose={onClose}>
      <div className="pb-[30px] pt-[20px] flex mdmax:hidden justify-center">
        {
          _payTypes.map((type, i) => (
            <div className="flex items-center cursor-pointer px-[12px]"
                 key={i}
                 onClick={() => selectPayType(type.type)}>
              <Radio checked={payType === type.type}/>
              <div className={`w-[140px]  rounded-[5px] border py-[20px] text-center bg-white`}>
                {t(type.name)}
              </div>
            </div>
          ))
        }
      </div>
      
      <div className="divide-y divide-[#eee] px-[15px] md:hidden">
        {
          _payTypes.map((type, i) => (
            <div className="flex items-center"
                 key={i}
                 onClick={() => selectPayType(type.type)}>
              <Radio checked={payType === type.type}/>
              <div className={`flex-1 rounded-[5px] py-[18px] ${payType === type.type ? 'border-[#FFC75A] bg-[#FFFCF5] text-[#FFC75A]' : 'border-[#ddd] text-[#666]'}`}>
                {t(type.name)}
              </div>
            </div>
          ))
        }
      </div>
    </Modal>
  );
}
